
export const useParams = () => {

  const searchParams = new URLSearchParams(window.location.search);
  
  const setSearchParams = (name, val) => {
     const newSearchParams = new URLSearchParams()
      for (const [key, value] of Object.entries(name)) {
        if(Array.isArray(value)){
            value.forEach(item=>{
                newSearchParams.append(key,item);
            })
        } else {
            newSearchParams.set(key,value);
        }
      }
    window.history.replaceState({}, "", '?' + newSearchParams);

};

return [searchParams, setSearchParams];
};